export const TABLE_DATA_INPUT_HEIGHT_CLASS = 'h-[34px]' as const;
export const TABLE_DATA_ROW_CELL_CLASSES =
  'box-border h-[50px] min-h-[50px] max-h-[50px] overflow-hidden py-0.5 px-3 text-ellipsis whitespace-nowrap' as const;
